import { render, staticRenderFns } from "./MailGraph.vue?vue&type=template&id=c382b9c6&"
import script from "./MailGraph.vue?vue&type=script&lang=js&"
export * from "./MailGraph.vue?vue&type=script&lang=js&"
import style0 from "./MailGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports